import { Controller } from "@hotwired/stimulus";

/**
 * Review Copy Controller
 *
 * Handles copying review text to clipboard and opening review links.
 *
 * @example
 * ```ruby
 * a href: link.url,
 *   target: "_blank",
 *   rel: "noopener noreferrer",
 *   class: "btn btn-outline w-full flex items-center gap-3 justify-start",
 *   data: {
 *     controller: "review-copy ahoy",
 *     action: "click->review-copy#copy",
 *     review_copy_review_text_value: "Review text here",
 *     ahoy_event_value: "$clicked_review_venue",
 *     ahoy_namespace_value: :users,
 *     ahoy_details_value: {
 *       platform: link.platform,
 *       url: link.url
 *     }.to_json
 *   }
 * ```
 */
export default class extends Controller {
  static values = {
    reviewText: String,
  };

  copy(event) {
    event.preventDefault();

    // Copy the review text to clipboard
    navigator.clipboard
      .writeText(this.reviewTextValue)
      .then(() => {
        // Show success toast
        this.dispatch("toast", {
          detail: {
            message: "Review copied to clipboard!",
            type: "success",
          },
        });

        // Open the review link in a new tab
        window.open(this.element.href, "_blank", "noopener,noreferrer");
      })
      .catch(() => {
        // Show error toast if copy fails
        this.dispatch("toast", {
          detail: {
            message: "Failed to copy review",
            type: "error",
          },
        });
      });
  }
}
